import React from 'react';
import BOM from "@system/config/bom";
import useReduxState from "../../../hooks/useReduxState";
import store from "../../../storeWire";
import { useBOMStore } from "../../../hooks/bom";
import System from "../../../helper/system";
import { Drag } from "../../../component/Global/DragAndDrop/Drag";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import AxiosSingletonLoader from 'src/component/Global/AxiosSingletonLoader';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import { SET_DOWNLOAD_LOADER } from 'src/store/slice/model/BOM';
import Helper from 'src/helper/Helper';
import { Tooltip } from 'src/component/Global/Tooltip';
import liveAuth from 'src/helper/liveAuth';

const BomListUl = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { listOfBOM, project_id } = props;
    const [{ }, { fetch_bom_project_detail_with_bom }, { copy_bom_by_bom_id }] = useBOMStore();
    const [find_bom_input_bom_listing] = useReduxState({}, 'find_bom_input_bom_listing');
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)

    const getDisplayClass = (singleBOM) => {
        if (!find_bom_input_bom_listing || find_bom_input_bom_listing === '') {
            return 'table-row'
        }
        if (!singleBOM.bomName.toLowerCase().includes(find_bom_input_bom_listing.toLowerCase())) {
            return 'none'
        }
        return 'table-row'
    };

    function bomOpen() {
        localStorage.setItem("adobeEventType", "bomOpened");
    }
    return (
        <>
            <ul style={{
                visibility: __check(['BOM_PROJECT_API_CALL']).status > 0 ? 'visible' : 'hidden'
            }}>
                <li>
                    <div className="table-responsive">
                        {/* <table className="table font-12"> */}
                        {__check(['BOM_PROJECT_API_CALL'], {}).render}
                        {/* </table> */}
                    </div>
                </li>
            </ul>
            <ul style={{
                visibility: !__check(['BOM_PROJECT_API_CALL']).status > 0 ? 'visible' : 'hidden'
            }}>
                <li>
                    <div className="table-responsive">
                        <table className="table font-12 bg-grey2">
                            <tbody>
                                {Object.keys(listOfBOM).map((v, i) => (
                                    <Drag key={i} data={listOfBOM[v]} dragFromProject={project_id ? true : false} className="draggable-row" style={{ display: getDisplayClass(listOfBOM[v]) }}>
                                        <td>
                                            <a href={BOM.getBomDetailByIdRouteURL(listOfBOM[v].bomId, { lifeCycle: listOfBOM[v].bomHealthRisk })}
                                                className="text-blue2 mb-1 d-block font-bold font-arial" onClick={bomOpen}>{listOfBOM[v].bomName}</a>
                                            <p>Last updated: {Helper.dateFormatFromString(listOfBOM[v].updatedDate, true)}</p>
                                        </td>
                                        <td>
                                            <div className="text-nowrap d-flex align-items-center">
                                                <i className="fa fa-check-circle me-1 text-darkgreen font-16" />
                                                <p><span>{listOfBOM[v]?.exactMatchCount}/{listOfBOM[v]?.totalCount}</span> exact matches</p>
                                            </div>
                                        </td>
                                        <td>
                                            {!(!isInternalUser && listOfBOM[v].isExternalBom) &&
                                                <div className="text-nowrap d-flex align-items-center">

                                                    <AxiosSingletonLoader slugKey={['BOM_OPERATION_API_CALL', 'BOM_PROJECT_API_CALL']}>
                                                        <i className="copy-icon font-14 me-2 "></i>
                                                        <a href={void (0)}
                                                            onClick={async () => {
                                                                await copy_bom_by_bom_id({ bomId: listOfBOM[v].bomId, source: "BOM" });
                                                                await fetch_bom_project_detail_with_bom()
                                                            }}
                                                        >Create Copy</a>
                                                    </AxiosSingletonLoader>
                                                </div>
                                            }
                                        </td>
                                        <td>
                                            {!(!isInternalUser && listOfBOM[v].isExternalBom) &&
                                                <>
                                                    {
                                                        listOfBOM[v].totalCount < 201 ?
                                                            (listOfBOM[v].isDownloadLoad ?
                                                                <AxiosIndicatorRunTimeLoader bomLoaderClass={true} /> :
                                                                <div className={"text-nowrap  d-flex align-items-center"}
                                                                    onClick={() => {
                                                                        store.dispatch(SET_DOWNLOAD_LOADER({ bomId: listOfBOM[v].bomId, isLoad: true, projectId: project_id }));
                                                                        System.popup('DownloadBomPopup', { single_bom: listOfBOM[v], manageLoad: true, projectId: project_id })
                                                                    }}
                                                                ><i className="fa fa-download font-16 me-1" /><a> Download</a></div>
                                                            ) :
                                                            <div className="text-nowrap"><i className="fa fa-download font-16 me-1" /><a className='disabled-link'> Download</a>
                                                                <Tooltip
                                                                    className='carttooltip'
                                                                    position={'bottom center'}
                                                                    opener={() => <i className={'fa fa-exclamation-circle font-16 ms-2'} />}
                                                                    content={() => <>
                                                                        <div className="text-center">
                                                                            For BOM larger than 200 parts please use EMAIL BOM
                                                                        </div>

                                                                    </>}
                                                                />
                                                            </div>
                                                    }
                                                </>
                                            }
                                        </td>
                                        <td>
                                            <div className="text-nowrap d-flex align-items-center">
                                                <i className="fa fa-trash-o me-1 font-16 font-bold" />
                                                <a
                                                    data-toggle="modal"
                                                    href={void (0)}
                                                    onClick={() => {
                                                        System.popup('BomDeletePopup', { single_bom: listOfBOM[v] })
                                                    }}> Delete </a>
                                            </div>
                                        </td>
                                    </Drag>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
        </>
    );
}

export default BomListUl;